import { defineStore } from "pinia";
import contractnet from "@/network/contractnet";
import basicnet from "@/network/optional.js";
import { useOrderStore } from "@/store/order";
import { routeParamsStore } from "@/store/routeParams";
import { useRoute } from "vue-router";
import { ElMessageBox } from "element-plus";

export const useContractStore = defineStore("contract", {
  persist: {
    paths: ["mode", "OrderId", "activeName", "cId", "OrderNumber"]
  },
  state: () => ({
    // 合同Id
    Id: 0,
    // 合同Id
    cId: "",
    // 合同类型
    ContractType: "",
    // 合同号码
    ContractNumber: "",
    // 合同状态
    Status: "",
    // 签约状态
    Signed: "",
    // 合同只要信息
    ContractSummary: {},
    // 订单Id
    OrderId: 0,
    // 订单状态
    OrderStatus: "",
    // 订单编号,
    OrderNumber: "",
    // 页面模式:view,edit
    mode: "view",
    // 合同类型
    ContractTypeOptions: [
      {
        label: "Media",
        value: "media",
      },
      {
        label: "Production",
        value: "production",
      },
      {
        label: "Media + Production",
        value: "media+production",
      },
      {
        label: "Media & Production",
        value: "media+production",
      },
    ],
    // 当前页面名称
    PageName: "",
    // 媒体合同类型
    MediaBookingOptions: [],
    // 制作合同类型
    ProductionBookingOptions: [],
    // MIA媒体结果
    MediaList: [],
    // 媒体类型设定列表
    MediaSettings: [],
    // 支付费用类型
    ProductionCostOptions: [],
    // 销售服务类型
    SalesServiceTypeOptions: [],
    // 支付类型
    PaymentTerms: [],
    // 支付类型选项
    PayTermOptions: [],
    // 发票类型
    InvoiceTerms: [],
    // 发票类型选项
    InvoiceOptions: [],
    // 付款状态
    PaymentStatusOptions: [],
    // 发票状态
    InvoiceStatusOptions: [],
    // 当前流程信息
    TaskFlow: {

    },
    activeName: "ContractInfo",
    Permission: {

    },
    // ReviseMessage: "",
    DeleteMediaAlert: "",
    bHasMedia: false,
    bHasInternalSplit: false,
    bPaymentSchedule: false,
    // bEnableSubmit: false,
    // bEnableReviseUnlock: false,
    // bEnableEdit: false,
    // bEnableRevise: false,
    // isApprove: false,
    // bEnableApprove: false,
    isPreview: false,
    bHasRevise: false,
    // bEnableSpecialPaymentTerm: false,
    //EnableEditMessage: "",
    // EnableSubmitMessage: "",
    // EnableReviseUnlockMessage: "",
    // EnableReviseMessage: "",
    // EnableApproveMessage: "",
    // bEnablePageUnlock: false,
    // EnablePageUnlockMessage: "",
    // bEnablePreview: false,
    // EnablePreviewMessage: "",
    // bEnableEditBilling: false,
    // EnableEditBillingMessage: "",
    bEnableSpecialDiscount: false,
    bEnterDraftContract: false,
    // bEnableSubmitJob: false,
    // EnableSubmitJobMessage: "",
    Unit: {},
    AdditionalInformation: {}, // Additional Information Tab
    PageTabActions: [],
    ProcessFlowCode: "",
    otherData: {},
    ContractFunctions: []
    // bPageVisit: false
  }),
  getters: {
    /**
     * 是否可以编辑付款期限
     * @returns
     */
    TermDisabled (state) {
      return (state.ContractSummary.businessNature || "") !== "Government";
    },
    isEditDisabled (state) {
      return (state.ContractSummary?.status || "Open") !== "Open"
    },
    isVoidContract (state) {
      return ((state.ContractSummary?.status || "Open") === "Approving" || (state.ContractSummary?.status || "Open") === "Issued") && state.ContractSummary.contractNumber === ""
    },
    bDisabledRevised (state) {
      return (state.ContractSummary?.status || "Open") === "Open" || (state.ContractSummary?.status || "Open") === "Void" || state.ContractSummary.contractNumber === ""
    },
    disabled (state) {
      return state.mode !== "edit"
    },
    ContractStatus (state) {
      return state.Status;
    },
  },
  actions: {
    // 初始化页面, 页面刷新才执行
    async Init (PageName) {
      const route = useRoute()
      //const ContractNo = route?.query?.ContractNo || ""
      const routeParams = routeParamsStore();

      //不为空,不是新建
      // if (ContractNo) {
      //   //从链接进来,参数跟query的不一样获取有参数为空时
      //   if (ContractNo != routeParams.contractParams.ContractNo || routeParams.contractParams.id || routeParams.contractParams.OrderNo || routeParams.contractParams.orderId) {
      //     const result = await contractnet
      //       .getContractInfo(ContractNo)
      //       .then((res) => res.data);
      //     //没有数据
      //     if (!result) {
      //       await ElMessageBox.alert("There is no data.", "Message", {
      //         confirmButtonText: "OK",
      //       })
      //         .then(() => {
      //         })
      //         .catch(() => {
      //         });
      //       //跳转主页
      //       window.location = '/report'
      //       return;
      //     }
      //     //设置参数传值
      //     routeParams.contractParams = {
      //       ContractNo: result.contractNumber,
      //       OrderNo: result.orderNumber,
      //       id: result.contractId,
      //       orderId: result.orderId,
      //       tabName: routeParams.contractParams.tabName,
      //       mode: 'view',
      //     };
      //     const useOrder = useOrderStore();
      //     //判断是否有权限
      //     if (routeParams.contractParams.OrderNo != useOrder.OrderNumber) {
      //       await useOrder.getDataAuthority(routeParams.contractParams.OrderNo);
      //     }
      //   }
      // }

      //const OrderNo = routeParams.contractParams.OrderNo;

      // const OrderNo = route.query.OrderNo
      if ((route?.query?.cId || "") !== "") {
        this.cId = route?.query?.cId
      }

      // 更新页面参数
      routeParams.UpdatePageParam({
        key: this.cId
      })

      var activeName = PageName || this.activeName
      if ((this.activeName || "") == "") {
        this.activeName = "ContractInfo"
      }

      await this.getContractBase(this.cId, this.OrderNumber, activeName)

      // if (!this.bPageVisit) {
      //   return;
      // }

      // 合同摘要
      await this.getContractSummary();

    },
    // 获取合同签约状态
    getSingnedStatus () {
      return this.Signed
    },
    async getContractBase (cId, OrderNo, PageAction, Unit) {
      const data = await contractnet.getContractBase(cId, OrderNo, PageAction, Unit).then(res => res.data)
      this.bPageVisit = data.bPageVisit
      if (!this.bPageVisit) {
        //是否有查看这条order的权限,没有权限提示,并返回主页

        await ElMessageBox.alert("No permission.", "Message", {
          confirmButtonText: "OK",
        })
          .then(() => {
          })
          .catch(() => {
          });
        //跳转主页
        window.location = '/report'
        return;
      }

      this.TaskFlow = data.taskFlow
      this.Id = data.contractId
      this.Status = data.status
      this.Signed = data.signed
      // this.ReviseMessage = data.reviseMessage
      this.bHasMedia = data.hasMedia
      this.bHasInternalSplit = data.hasInternalSplit
      this.bPaymentSchedule = data.bPaymentSchedule
      // this.bEnableSubmit = data.bEnableSubmit
      // this.EnableSubmitMessage = data.enableSubmitMessage
      // this.bEnableEdit = data.bEnableEdit
      // this.EnableEditMessage = data.enableEditMessage
      // this.bEnableRevise = data.bEnableRevise
      // this.EnableReviseMessage = data.enableReviseMessage
      // this.bEnableReviseUnlock = data.bEnableReviseUnlock
      // this.EnableReviseUnlockMessage = data.enableReviseUnlockMessage
      // this.isApprove = data.isApprove
      // this.bEnableApprove = data.bEnableApprove
      // this.EnableApproveMessage = data.enableApproveMessage
      this.isPreview = data.isPreview
      this.bHasRevise = data.hasRevise
      // this.bEnableSpecialPaymentTerm = data.bEnableSpecialPaymentTerm
      // this.bEnablePageUnlock = data.bEnablePageUnlock
      // this.EnablePageUnlockMessage = data.enablePageUnlockMessage
      // this.bEnablePreview = data.bEnablePreview
      // this.EnablePreviewMessage = data.enablePreviewMessage
      // this.bEnableEditBilling = data.bEnableEditBilling
      // this.EnableEditBillingMessage = data.enableEditBillingMessage
      this.bEnableSpecialDiscount = data.bEnableSpecialDiscount
      this.bEnterDraftContract = data.bEnterDraftContract
      this.Unit = data.unit
      this.ContractType = data.contractType
      this.OrderStatus = data.orderStatus
      this.DeleteMediaAlert = data.deleteMediaAlert
      //this.bEnableSubmitJob = data.bEnableSubmitJob
      //this.EnableSubmitJobMessage = data.enableSubmitJobMessage
      this.AdditionalInformation = data.additionalInformation
      this.PageTabActions = data.pageTabActions
      this.ProcessFlowCode = data.processFlowCode
      this.ContractFunctions = data.contractFunctions
      this.otherData = data.otherData;


      // const routeParams = routeParamsStore();
      // routeParams.FunctionCode = data.functionName

      if ((this.TaskFlow.processFlowStatus || "Submit") !== "Submit") {
        if (this.Status !== "Open") {
          this.mode = "Approving"
        }


        if (this.TaskFlow.processFlowStatus === "Completed") {
          this.mode = "Approved"
        }
      }


      if (data.orderId !== 0) {
        this.OrderId = data.orderId
      }
    },
    /**
     * 合同摘要信息
     */
    async getContractSummary () {
      const order_res = await contractnet
        .getContractSummary(this.OrderId, this.cId)
        .then((res) => res);

      this.ContractSummary.advertiserName = order_res.data.advertiser;
      this.ContractSummary.productName = order_res.data.product;
      this.ContractSummary.createByName = order_res.data.createByName;
      this.ContractSummary.createDate = order_res.data.createDate;
      this.ContractSummary.updateByName = order_res.data.updateByName;
      this.ContractSummary.updateDate = order_res.data.updateDate;
      this.ContractSummary.contractParty = order_res.data.contractingParty;
      this.ContractSummary.contractNumber = order_res.data.contractNumber;
      this.ContractSummary.status = order_res.data.status;
      this.ContractSummary.orderNumber = order_res.data.orderNo;
      this.ContractSummary.businessNature = order_res.data.businessNature;
      this.ContractSummary.isAgencyDiscount = order_res.data.isAgencyDiscount;
      this.ContractSummary.agencyDiscountRate = order_res.data.agencyDiscountRate;
      this.ContractSummary.isNewClient = order_res.data.isNewClient;
      this.ContractSummary.contractNumberMediaOrProduction = order_res.data.contractNumberMediaOrProduction;
      this.ContractSummary.signed = order_res.data.signed;
      this.ContractSummary.contractType = order_res.data.contractType;
      this.ContractSummary.clientType = order_res.data.clientType;
      this.ContractSummary.templateContractNumber = order_res.data.templateContractNumber;
      this.ContractSummary.isITC = order_res.data.isITC;

    },
    getContractSummaryData () {
      return { ...this.ContractSummary };
    },
    setContractSummaryData (value) {
      this.ContractSummary = value
    },
    changeId (id) {
      this.Id = id
    },
    /**
     * 更新模式
     * @param {*} mode 模式:View/Edit
     */
    changeMode (mode) {
      this.mode = mode;

      const routeParams = require('./routeParams')?.routeParamsStore();
      routeParams.setPageMode(mode)

    },
    /**
     * 更新页面名称
     * @param {*} tabName 当前页面名称
     */
    changePageName (PageName) {
      this.PageName = PageName;
    },
    /**
     * 合同选项
     */
    async getContractInfoOptions () {
      // 媒体合同类型
      // 读取选项
      this.MediaBookingOptions = await basicnet
        .getMediaContractTypeOptionals()
        .then((res) => res.data);

      // 制作合同类型
      this.ProductionBookingOptions = await basicnet
        .getProductionBookingTypeOptionals()
        .then((res) => res.data);
    },
    /**
     * 付款时间所有的选项
     */
    async getPaymentOptions () {
      const op_res = await basicnet
        .getContractPaymentScheduleOptions(this.ContractSummary.businessNature)
        .then((res) => res.data);
      this.PaymentTerms = op_res.paymentterms;
      this.InvoiceTerms = op_res.invoiceterms;

      if (this.PaymentTerms.length > 0) {
        this.PayTermOptions = this.PaymentTerms.map(t => { return { value: t.code, label: t.name } })
      }
      if (this.InvoiceTerms.length > 0) {
        this.InvoiceOptions = this.InvoiceTerms.map(t => { return { value: t.code, label: t.name } })
      }

      this.PaymentStatusOptions = op_res.paystatusOptions;
      this.InvoiceStatusOptions = op_res.invoicestatusOptions;
    },
    async getSalesServiceOptions () {
      this.SalesServiceTypeOptions = await basicnet
        .getSalesServiceFeeOptionals()
        .then((res) => res.data);
    },
    /**
     * 审批合同
     */
    async approveContract (ApproveModel) {
      //提交修改数据
      var message = await contractnet
        .approveContract(ApproveModel)
        .then((res) => res.data);

      if ((message || "") === "") {
        //更新列表信息
        const useOrder = useOrderStore();
        await useOrder.getOrder(useOrder.OrderNumber);
      }

      return message;

    },
    /**
    * 批量审批合同
    */
    async bulkApproveContract (contractIds) {
      //提交修改数据
      this.SalesServiceTypeOptions = await contractnet
        .bulkApproveContract(contractIds)
        .then((res) => res.data);
      //更新列表信息
      const useOrder = useOrderStore();
      useOrder.getOrder(useOrder.OrderNumber);

    },
    /**
     * 获取合同类型
     * @returns 
     */
    getContractType () {
      return this.ContractType
    },
    /**
     * 获取合同类型
     * @returns 
     */
    getOrderStatus () {
      return this.OrderStatus
    },
    /**
     * 获取删除提示
     * @returns String
     */
    getDeleteMediaAlert () {
      return this.DeleteMediaAlert
    },
    getAdditionalInformation () {
      return this.AdditionalInformation
    },
    setAdditionalInformation (value) {
      this.AdditionalInformation = value
    },
    setRemarks (value) {
      this.AdditionalInformation.remarks = value
    },
    getPageTabActions () {
      return [...this.PageTabActions]
    },
    getFunctionPermission (alias) {
      return this.getPageTabActions().find(t => t.alias === alias)
    },
    getOrderId () {
      return this.OrderId;
    },
    /**
     * 获取流程信息
     * @returns 
     */
    getTaskFlow () {
      var taskflow = { ...this.TaskFlow }
      taskflow.process_flow_name = this.ProcessFlowCode
      return taskflow
    },
    getCId () {
      return this.cId
    },
    getBusinessUnit () {
      return { ...this.Unit }
    },
    getContractFunctionPermission (alias) {
      return this.ContractFunctions.find(t => t.alias == alias)
    }
  },
});
